<template>
  <SoPageWithHeader title="Create Article">
    <NewsfeedEnvironmentWarning />
    <AdminNewsfeedArticleForm mode="create" @success="onSuccess" />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import AdminNewsfeedArticleForm from "./components/AdminNewsfeedArticleForm.vue"
  import NewsfeedEnvironmentWarning from "./components/NewsfeedEnvironmentWarning.vue"
  import { RouteNames } from "@/types/router"

  export default defineComponent({
    components: {
      SoPageWithHeader,
      AdminNewsfeedArticleForm,
      NewsfeedEnvironmentWarning,
    },
    methods: {
      onSuccess(articleId: string) {
        this.$router.push({
          name: RouteNames.AdminNewsfeedEdit,
          params: { articleId },
        })
      },
    },
  })
</script>
